import React, { useState, useEffect } from 'react';
import Papa from 'papaparse';
import ConverterLayout from './ConverterLayout';
import { Alert, Box, Typography } from '@mui/material';
import SEO, { createSoftwareAppSchema } from '../../components/SEO';

function CsvToJson() {
  const [csv, setCsv] = useState('id,name,value\n1,Item A,100\n2,Item B,200');
  const [json, setJson] = useState('');
  const [error, setError] = useState('');

  const handleConvert = () => {
    setError('');
    if (!csv.trim()) {
      setJson('');
      return;
    }

    Papa.parse(csv, {
      header: true,
      skipEmptyLines: true,
      complete: (result) => {
        if (result.errors.length) {
          setError(result.errors[0].message);
          setJson('');
        } else {
          setJson(JSON.stringify(result.data, null, 2));
        }
      },
    });
  };

  const handleClear = () => {
    setCsv('');
    setJson('');
    setError('');
  };

  // Auto-convert sample data on load
  useEffect(() => {
    handleConvert();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <SEO
        title="CSV to JSON Converter | Free Online Tool | UmbrellaCo"
        description="Instantly convert CSV files or text to formatted JSON. Automatically parses headers, handles nested data, and provides clean JSON output online."
        keywords="csv to json, convert csv to json, csv to json converter online, parse csv, online json tools"
        url="/json-tools/csv-to-json"
        jsonLd={createSoftwareAppSchema(
          'CSV to JSON Converter',
          'Instantly convert CSV files or text to formatted JSON.',
          'https://umbrellaco.in/json-tools/csv-to-json',
          ['CSV Parsing', 'JSON Formatting', 'Header Detection']
        )}
      />
      {error && <Alert severity="error" sx={{ mx: 2, mb: 1 }}>{error}</Alert>}
      <Box sx={{ flexGrow: 1, minHeight: 0, overflow: 'hidden' }}>
        <ConverterLayout
          title="CSV to JSON Converter"
          description="Paste your Comma-Separated Values (CSV) to convert it into a structured JSON array of objects."
        leftTitle="CSV"
        rightTitle="JSON"
        leftLanguage="plaintext"
        rightLanguage="json"
        leftValue={csv}
        setLeftValue={setCsv}
        rightValue={json}
        onConvert={handleConvert}
        onClear={handleClear}
        />
      </Box>
    </Box>
  );
}

export default CsvToJson;